<!--  -->
<template>
     <div class='wrapper box_v'>
        <div class="title">学生报名申请</div>
        <div class="card7_box box-v">
          <div class="card7listTitle box ac">
            <div>姓名</div><div>类别</div><div class="box_f1">学生类型</div><div>状态</div>
          </div>
          <div v-for="(item,index) in list" :class="index%2!=0?'card1list card1listbg':'card1list'">
            <div>张丽娜</div>
            <div>幼升小</div>
            <div class="box_f1">自购商品房城区户籍</div>
            <div class="successtype" v-if="item.type==3">审核成功</div>
            <div class="failtype" v-if="item.type==2">审核失败</div>
            <div class="waittype" v-if="item.type==1">上报审核</div>
          </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
          list:[{type:1},{type:2},{type:1},{type:3}]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        //this.initEcharts()
        //this.initHighChart()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    height:100%;
    width:100%;
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
    background-size: 100% 100%;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px
}
.card7_box{width: 100%;}
.card7listTitle{width: 100%;height: 38px;align-items: center;font-size: 16px;color: #FFFFFF;margin-top: 18px;
background: linear-gradient(90deg, rgba(21, 144, 245, 0) 0%, #0067BC 48%, rgba(21, 144, 245, 0) 100%);
}
.card7listTitle div:nth-child(1){width: 70px;text-align: center;}
.card7listTitle div:nth-child(2){width: 73px;text-align: center;}
.card7listTitle div:nth-child(3){text-align: left;}
.card7listTitle div:nth-child(4){width: 70px;text-align: center;margin-right: 40px;}

.card1list{width: 100%;display: flex;display: -webkit-flex;height: 38px;align-items: center;font-size: 16px;color: #FFFFFF;}
.card1listbg{background: linear-gradient(90deg, rgba(0, 252, 255, 0.2) 0%, rgba(0, 25, 36, 0.2) 100%);}
.card1list div:nth-child(1){width: 70px;text-align: center;}
.card1list div:nth-child(2){width: 73px;text-align: center;}
.card1list div:nth-child(3){text-align: left;}
.card1list div:nth-child(4){width: 70px;text-align: center;margin-right: 40px;}
.card1list div.successtype{width: 70px;text-align: center;margin-right: 40px;font-style: italic;color: #0EFCFF;background: linear-gradient(180deg, #00D8B7 0%, #00C38A 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;}
.card1list div.failtype{width: 70px;text-align: center;margin-right: 40px;font-style: italic;color: #0EFCFF;background: linear-gradient(180deg, #FF8989 0%, #FF311C 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;}
.card1list div.waittype{width: 70px;text-align: center;margin-right: 40px;font-style: italic;color: #0EFCFF;background: linear-gradient(180deg, #22A5FF 0%, #00E4FF 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;}

</style>
